module.exports = __webpack_public_path__ + "images/application/illustrations/email-stack-ribbon-d581887c.svg";